module.exports = __webpack_public_path__ + "media/55.27c2349c.mp3";